import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import sha1 from 'js-sha1';

import './GroupMembersComponent.scss';
import blocks from '../../blocks';
import elements from '../../elements';
import styled from './styled';
import AddRemoveMembersModal from 'pages/CommunityMergeFeed/CreateFeed/AddRemoveMembersModal';

class GroupMembersComponent extends React.Component {
  state = {
    admins: [],
    members: [],
    showActionsMenu: false,
    showModal: false,
    mode: null, // 'add' or 'remove'
  };

  componentDidMount() {
    this.filterChannelUsers();
  }

  componentDidUpdate(prevProps) {
    const { allUsers, activeChannel, activeChannelRefreshToken, managers, associates } = this.props;
    console.log('componentDidUpdate', activeChannelRefreshToken, activeChannel);
    if (prevProps.allUsers !== allUsers || prevProps.activeChannel !== activeChannel || prevProps.activeChannelRefreshToken !== this.props.activeChannelRefreshToken
      || managers !== this.props.managers || associates !== this.props.associates
    ) {
      this.filterChannelUsers();
    }
  }

  filterChannelUsers = () => {
    const { allUsers, activeChannel, managers, associates } = this.props;
    if (!activeChannel || !Array.isArray(allUsers) || !Array.isArray(managers) || !Array.isArray(associates)) return;

    const activeUsersList = managers.concat(associates);
    const usersInChannel = activeUsersList.filter(
      (user) =>
        user.user &&
        user.status === 'active' &&
        user.user.channel_ids.includes(activeChannel.id)
    );

    this.setState({
      admins: usersInChannel.filter((u) => u.is_admin),
      members: usersInChannel.filter((u) => !u.is_admin),
    });
  };

  getUserUUID = (id) => `user.${sha1(`user.${id}`)}`;

  handleClose = (e) => {
    e.preventDefault();
    this.props.setActiveSidePane('group-details');
  };

  toggleActionsMenu = () => {
    this.setState((prevState) => ({ showActionsMenu: !prevState.showActionsMenu }));
  };

  openModal = (mode) => {
    this.setState({ showModal: true, mode, showActionsMenu: false });
  };

  closeModal = () => {
    this.setState({ showModal: false, mode: null });
  };

  handleConfirm = (selectedUserIds, channelId, mode) => {
    const { allUsers, activeChannel, active, addRemoveChannelUsers } = this.props;
    const subId = active?.subscriptions?.id;
    addRemoveChannelUsers(selectedUserIds, channelId, mode, subId);
    this.closeModal();
  };

  renderUser = (user) => {
    const { onlineUsers = [] } = this.props;
    const avatar = user.profile_image_thumb_url || '/icons/default-profile-thumb.svg';
    const isOnline = onlineUsers.includes(this.getUserUUID(user.owner_id));
    const bottomLine = user.position && user.badge_id ? (
      <styled.BottomLineWrap>
        <styled.BottomLineText>{user.position}</styled.BottomLineText>
        <styled.Dot />
        <styled.BottomLineText>{user.badge_id}</styled.BottomLineText>
      </styled.BottomLineWrap>
    ) : (
      <styled.BottomLineTextOneItem>{user.position || user.badge_id || ''}</styled.BottomLineTextOneItem>
    );

    return (
      <styled.MessageWrap key={user.id}>
        <styled.AvatarWrap>
          <styled.ProfileAvatar src={avatar} />
          {isOnline && <styled.OnlineMark />}
        </styled.AvatarWrap>
        <styled.InfoWrap>
          <styled.Name>
            {`${user.first_name} ${user.last_name}`}
            {user.is_admin && <styled.ApprovedBadge src="/icons/verified-badge-icon.svg" />}
          </styled.Name>
          {bottomLine}
        </styled.InfoWrap>
      </styled.MessageWrap>
    );
  };

  render() {
    const { admins, members, showModal, mode, showActionsMenu } = this.state;
    const { activeChannel, active, allUsers } = this.props;

    const channelType = activeChannel?.channel_type;
    const canModifyGroup = !['location_feed'].includes(channelType) &&
      !activeChannel?.shyft_channel &&
      active?.subscriptions?.channel?.is_admin;

    return (
      <elements.ColumnWrap>
        <div className="group__wraps">
          <img src="/icons/week-picker-left.svg" alt="Back" onClick={this.handleClose} />
          <label className="group__titles">
            <FormattedMessage id="GroupMembersComponent.header" defaultMessage="Group Members" />
          </label>
          {canModifyGroup && (
            <button
              className="group__button-more"
              aria-label="More actions"
              onClick={this.toggleActionsMenu}
            />
          )}
          {showActionsMenu && (
            <div className="action-menu">
              <div className="action-item" onClick={() => this.openModal('add')}>
                <img src="/icons/add-group-members.svg" alt="" />
                <span>Add members to group</span>
              </div>
              <div className="action-item" onClick={() => this.openModal('remove')}>
                <img src="/icons/remove-group-members.svg" alt="" />
                <span>Remove members from group</span>
              </div>
            </div>
          )}
        </div>

        <elements.ScrollWrap isLoading={false}>
          <div className="listSeparator">
            <label className="listSeparator__text">
              <FormattedMessage id="GroupMembersComponent.admins" defaultMessage="Admins" />
            </label>
            <label className="listSeparator__number">({admins.length})</label>
          </div>
          {admins.map(this.renderUser)}

          <div className="listSeparator">
            <label className="listSeparator__text">
              <FormattedMessage id="GroupMembersComponent.members" defaultMessage="Members" />
            </label>
            <label className="listSeparator__number">({members.length})</label>
          </div>
          {members.map(this.renderUser)}
        </elements.ScrollWrap>

        {showModal && (
          <AddRemoveMembersModal
            channelId={activeChannel.id}
            mode={mode}
            allUsers={allUsers}
            channelUsers={[...admins, ...members]}
            onClose={this.closeModal}
            onConfirm={this.handleConfirm}
            title={mode === 'add' ? 'Add Group Members' : 'Remove Group Members'}
            confirmLabel={mode === 'add' ? 'Add' : 'Remove'}
          />
        )}
      </elements.ColumnWrap>
    );
  }
}

GroupMembersComponent.propTypes = {
  allUsers: PropTypes.array.isRequired,
  activeChannel: PropTypes.object,
  onlineUsers: PropTypes.array,
  setActiveSidePane: PropTypes.func.isRequired,
  addRemoveChannelUsers: PropTypes.func.isRequired,
  active: PropTypes.object,
};

export default injectIntl(GroupMembersComponent);
